export default class Jurisdiction {
  constructor(jurisdictionId: number, description: string, count: number) {
    this.jurisdictionId = jurisdictionId;
    this.description = description;
    this.count = count;
  }

  static createFromRequest(request: any): Jurisdiction {
    return new Jurisdiction(request.jurisdictionId,
      request.description,
      request.count);
  }

  jurisdictionId: number;
  description: string;
  count: number;
}



// WEBPACK FOOTER //
// ./src/models/jurisdiction.ts